var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home_top"},[_c('img',{staticClass:"home_top_back",attrs:{"src":require("../assets/image/black_icon01.png"),"alt":"返回"},on:{"click":function($event){return _vm.toBackFn()}}}),_c('div',{staticClass:"home_top_title"},[_vm._v(_vm._s(_vm.topTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }